type Args = {
  value: string;
  allowDecimal: boolean;
  decimalSeparator: string;
};

export function currencyInputDelimiterSanitize({
  value,
  allowDecimal,
  decimalSeparator,
}: Args): string {
  if (!allowDecimal) {
    // Remove any character that's not a digit
    return value.replace(/[^0-9]/g, '');
  }

  const escapedDecimalSeparator =
    decimalSeparator === '.' ? '\\.' : decimalSeparator;

  return (
    value
      // Remove any character that's not a digit or decimal separator
      .replace(new RegExp(`[^0-9${escapedDecimalSeparator}]`, 'g'), '')
      // Allow only one decimal separator
      .replace(
        new RegExp(`(${escapedDecimalSeparator})\\1+`, 'g'),
        decimalSeparator,
      )
  );
}
